import { Button } from "@mui/material";
import React from "react";
import { motion } from "framer-motion";
import { Icon } from "@iconify/react";

const DraggableFloatingButton = ({ handleClick }) => {
  return (
    <motion.div
      animate={{ rotate: 360 }}
      transition={{ repeat: Infinity, duration: 2, ease: "linear" }}
    >
      <Button
        sx={{
          background: "linear-gradient(to right, #702dff, black, black)",
          color: "white",
          height: 30,
          width: 30,
          minWidth: 30,
          borderRadius: "50%",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
        }}
        size="small"
        onClick={handleClick}
      >
        <Icon icon="radix-icons:update" width="25" height="25" />
      </Button>
    </motion.div>
  );
};

export default DraggableFloatingButton;
